import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Portfolio from "@/components/site/Portfolio";
import Services from "@/components/site/Services";
import Pricing from "@/components/site/Pricing";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import InstallApp from "@/components/site/InstallApp";

export default function HomePage() {
    return (
        <div data-testid="home-page" className="bg-ivory text-navy">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Portfolio />
                <Services />
                <Pricing />
                <Process />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
            <InstallApp />
        </div>
    );
}
